import styled from "styled-components";
import { COLORS } from "../../../../utils/constants";

export const InvoiceStateContainer = styled.div<{ paid: boolean }>`
  color: ${({ paid }) => (paid ? COLORS.green : COLORS.orange)};
`;
